function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.73245 0.760894C3.98922 0.97098 4.92816 7.22388 7.41628 9.07638C8.92583 10.4257 8.94269 10.5274 7.08504 9.5104C3.70687 7.38918 0.134838 8.86711 0.0320092 12.4255C-0.149205 18.1777 6.87348 18.6499 8.31982 13.8587C8.43445 13.2284 9.01939 12.4524 8.97557 13.6291C8.88117 15.5638 6.34416 20.3795 6.13935 20.3176H12.5484C12.0722 19.1703 10.4615 16.2226 10.4278 13.8514C10.4666 12.2073 10.8813 13.2805 11.1265 14.1005C12.5535 18.9814 19.4877 18.1874 19.6917 13.0688C19.7785 9.3451 16.1061 7.0879 13.0794 9.29054C11.3575 10.455 11.3406 10.1586 12.7237 8.68797C15.8634 5.5774 14.1018 0.60048 9.73245 0.760894Z",
  fill: "currentColor"
});

function SvgSuitClub(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuitClub);
export default __webpack_public_path__ + "static/media/suitClub.2442e2e0.svg";
export { ForwardRef as ReactComponent };